module.exports = __webpack_public_path__ + "img/Winzig.02278684.jpg";